import Vue from "vue";

const log = {
  todo: (messages) => {
    let message = "";

    if (!messages) return;

    if (Array.isArray(messages) && messages.length > 0) {
      message = "☑ " + messages.join("\n☑ ");
    } else {
      message = "☑ " + messages;
    }

    console.log(
      `%c[TODO]\n%c---\n${message}`,
      "background:black; color: #bada55; font-weight:bold;",
      "color: #bada55;"
    );
  },
};

Vue.prototype.$log = { ...log };

export default log;
